import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import React, { useState } from "react";
import { translate } from "react-multi-lang";
import { useNavigate } from "react-router-dom";

import { getPageTitle } from "../../utils/brandingConfig";

import Login from "./Login";
import Welcome from "./Welcome";

const LandingPageIndex = ({
  title,
  modalShow,
  fullscreen,
  setModalShow,
  ...props
}) => {
  const navigate = useNavigate();
  const [isProcessed, setIsProcessed] = useState(false)

  const handelLogin = () => {
    setIsProcessed(true)
    setTimeout( () => {
      setModalShow("login")
      setIsProcessed(false)
    }, 10)
  }

  return (
    <>
      <Helmet>
        <title>{title || getPageTitle(modalShow)}</title>
      </Helmet>
      <div className="h-100 login">
        {modalShow === "welcome" ? (
          <Welcome
            fullscreen={fullscreen}
            showLogin={handelLogin}
            processed={isProcessed}
          />
        ) : null}
        {modalShow === "login" ? <Login setShow={setModalShow} /> : null}
      </div>
    </>
  );
};

const mapStateToPros = (state) => ({
  login: state.users.loginInputData,
  signup: state.users.registerInputData,
  forgotPassword: state.users.forgotPasswordInputData,
  validation: state.users.validationInputData,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(translate(LandingPageIndex));
